(function () {
  'use strict';

  function loadModelViewer() {
    if (!document.querySelector('model-viewer')) return;
    if (window.customElements && window.customElements.get('model-viewer')) return;
    if (document.querySelector('script[data-model-viewer-loader]')) return;

    var script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';
    script.setAttribute('data-model-viewer-loader', 'true');
    document.head.appendChild(script);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadModelViewer, { once: true });
  } else {
    loadModelViewer();
  }
})();
